
import { Component, Vue } from "vue-property-decorator"
import Header from "@/components/Header.vue"

@Component({
  components: {
    Header,
  },
  head: {
    title: {
      inner: "",
      separator: "",
    },
    meta() {
      return [{ name: "robots", content: "noindex, nofollow" }]
    },
  },
})
export default class DefaultLayout extends Vue {}
